import { Skeleton } from "antd";
import type { CSSProperties } from "react";

interface FullPageSkeletonProps {
    variant?: "full" | "card" | "compact" | "table";
    rows?: number;
    blocks?: number;
    style?: CSSProperties;
}

const variantConfig = {
    full: {
        titleWidth: "30%",
        contentWidth: "50%",
        rows: 6,
        blocks: 2,
        spacing: "1.5rem",
        padding: "0",
    },
    card: {
        titleWidth: "40%",
        contentWidth: "60%",
        rows: 3,
        blocks: 1,
        spacing: "1rem",
        padding: "0.5rem",
    },
    compact: {
        titleWidth: "50%",
        contentWidth: "70%",
        rows: 2,
        blocks: 1,
        spacing: "0.75rem",
        padding: "0.25rem",
    },
    table: {
        titleWidth: "35%",
        contentWidth: "100%",
        rows: 8,
        blocks: 1,
        spacing: "1rem",
        padding: "0",
    },
};

export const FullPageSkeleton = ({
    variant = "full",
    rows,
    blocks,
    style,
}: FullPageSkeletonProps) => {
    const config = variantConfig[variant];
    const paragraphRows = rows ?? config.rows;
    const blockCount = blocks ?? config.blocks;

    return (
        <div
            style={{
                padding: config.padding,
                width: "100%",
                maxWidth: "100%",
                overflow: "hidden",
                ...style,
            }}
        >
            {/* Page/Card title */}
            <Skeleton
                active
                title={{ width: config.titleWidth }}
                paragraph={false}
            />

            {/* Spacing */}
            <div style={{ height: config.spacing }} />

            {/* Content blocks */}
            {Array.from({ length: blockCount }).map((_, index) => (
                <div key={index}>
                    <Skeleton
                        active
                        paragraph={{ rows: paragraphRows }}
                        title={{ width: config.contentWidth }}
                    />
                    {index < blockCount - 1 && (
                        <div style={{ height: config.spacing }} />
                    )}
                </div>
            ))}
        </div>
    );
};
